(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  if (!canHover.matches) return;

  function saveAndSwapImages(card, imageUrl) {
    if (!card || !imageUrl) return;

    const images = card.querySelectorAll('.product-media__image');

    images.forEach((img) => {
      if (!img.dataset.ascuaOriginalSrc) {
        img.dataset.ascuaOriginalSrc = img.getAttribute('src') || '';
        img.dataset.ascuaOriginalSrcset = img.getAttribute('srcset') || '';
        img.dataset.ascuaOriginalMaxResolution =
          img.getAttribute('data-max-resolution') || '';
      }

      img.src = imageUrl;
      img.srcset = imageUrl;

      if (img.hasAttribute('data-max-resolution')) {
        img.setAttribute('data-max-resolution', imageUrl);
      }
    });

    card.classList.add('ascua-color-preview-active');
  }

  function restoreImages(card) {
    if (!card) return;

    const images = card.querySelectorAll('.product-media__image');

    images.forEach((img) => {
      if (!img.dataset.ascuaOriginalSrc) return;

      img.src = img.dataset.ascuaOriginalSrc;

      if (img.dataset.ascuaOriginalSrcset) {
        img.srcset = img.dataset.ascuaOriginalSrcset;
      } else {
        img.removeAttribute('srcset');
      }

      if (img.dataset.ascuaOriginalMaxResolution) {
        img.setAttribute(
          'data-max-resolution',
          img.dataset.ascuaOriginalMaxResolution
        );
      }

      delete img.dataset.ascuaOriginalSrc;
      delete img.dataset.ascuaOriginalSrcset;
      delete img.dataset.ascuaOriginalMaxResolution;
    });

    card.classList.remove('ascua-color-preview-active');
  }

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest('.ascua-card-swatch');

    if (!swatch) return;

    if (swatch.contains(event.relatedTarget)) return;

    const imageUrl = swatch.dataset.imageUrl;
    const card = swatch.closest('product-card');

    if (!imageUrl || !card) return;

    restoreImages(card);
    saveAndSwapImages(card, imageUrl);
  });

  document.addEventListener('pointerout', (event) => {
    const swatch = event.target.closest('.ascua-card-swatch');

    if (!swatch) return;

    if (swatch.contains(event.relatedTarget)) return;

    const nextSwatch =
      event.relatedTarget?.closest?.('.ascua-card-swatch');

    if (nextSwatch && nextSwatch.closest('product-card') === swatch.closest('product-card')) {
      return;
    }

    const card = swatch.closest('product-card');

    restoreImages(card);
  });
})();